import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Your custom CSS
import {  ThemeProvider } from '@mui/material/styles';
import { theme } from 'helpers';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
  </React.StrictMode>
);